import React from 'react';
import Card from '../../../components/card';
import { BranchesOutlined } from '@ant-design/icons';
import {
  CircleStackIcon,
  Bars4Icon,
  ArrowTrendingUpIcon,
} from '@heroicons/react/24/solid';
import { twMerge } from 'tailwind-merge';
import { useQuery } from '@tanstack/react-query';
import { queryStatistic } from '../../../adapters/dashboard';
import { IDashboardStatisitc } from '../../../interfaces/dashboard';
import { AxiosResponse } from 'axios';
import { Skeleton } from 'antd';

interface IDashboardCardProps {
  name: string;
  icon: React.ReactNode;
  iconClassName: string;
  nameClassName: string;
  value: number;
  isLoading: boolean;
}

const DashboardCard = ({
  name,
  icon,
  value,
  nameClassName,
  iconClassName,
  isLoading,
}: IDashboardCardProps) => {
  return (
    <Card customClass="p-2 shadow-lg">
      {isLoading ? (
        <Skeleton active />
      ) : (
        <div className="flex justify-between w-full items-center border-2 border-green-500 border-dashed rounded-md p-3">
          <div className="flex flex-row items-center gap-3">
            <div
              className={twMerge(
                'flex rounded-full bg-orange-700 text-white items-center w-12 h-12 justify-center',
                iconClassName,
              )}
            >
              <div className="flex">{icon}</div>
            </div>
            <div className={twMerge('font-bold text-xl', nameClassName)}>
              {name}
            </div>
          </div>
          <div className="flex flex-col">
            <div className="flex font-bold text-black text-2xl">
              {Number(value).toLocaleString(undefined, {
                minimumFractionDigits: 0,
                maximumFractionDigits: 2,
              })}
            </div>
          </div>
        </div>
      )}
    </Card>
  );
};

const Statistic = () => {
  const { data, isLoading } = useQuery<
    AxiosResponse<IDashboardStatisitc>,
    Error
  >({
    queryKey: ['statistic'],
    queryFn: async () => await queryStatistic(),
  });

  return (
    <div className="grid md:grid-cols-4">
      <DashboardCard
        icon={<BranchesOutlined className="flex h-10 w-full" />}
        iconClassName="bg-pink-700 "
        name="ลูกค้า"
        nameClassName="text-pink-700"
        value={data?.data?.customer || 0}
        isLoading={isLoading}
      />
      <DashboardCard
        icon={<CircleStackIcon className="flex  h-5 w-full" />}
        iconClassName=" "
        name="สินค้า"
        nameClassName="text-blue-700"
        value={data?.data?.product || 0}
        isLoading={isLoading}
      />
      <DashboardCard
        icon={<Bars4Icon className="flex  h-5 w-full" />}
        iconClassName="bg-orange-600 "
        name="ออเดอร์"
        nameClassName="text-orange-600"
        value={data?.data?.order || 0}
        isLoading={isLoading}
      />
      <DashboardCard
        icon={<ArrowTrendingUpIcon className="flex  h-5 w-full" />}
        iconClassName="bg-green-600 "
        name="ยอดขาย"
        nameClassName="text-green-600"
        value={data?.data?.total || 0}
        isLoading={isLoading}
      />
    </div>
  );
};

export default Statistic;
